/* Henne · welcome popup (sections/henne-welcome-popup.liquid).
 * Opens once the visitor has spent `delay` seconds on the site (counted across pages in this tab) or, on desktop,
 * when the pointer leaves the top of the window. Never for visitors who already signed up; not again for `hide-days`
 * after closing; at most once per browser session. ?hn_welcome=preview opens it even when the section is switched off.
 * After a successful sign-up Shopify reloads the page with ?customer_posted=true: the section renders the success
 * state, this script opens it, visits /discount/<code> so the code is applied at checkout, and cleans the URL. */
(function () {
  var root = document.querySelector("[data-hn-welcome]");
  if (!root || root.hasAttribute("data-hn-ready")) return;
  root.setAttribute("data-hn-ready", "");
  // The footer section wrapper makes its own stacking context; move the form (with the popup) to <body> so the
  // popup sits above the header, drawers and the chat bubble. Remember the section first for the theme editor.
  var sectionEl = root.closest(".shopify-section");
  var formEl = root.closest("form");
  var portal = formEl || root;
  var designMode = !!(window.Shopify && window.Shopify.designMode); // the editor re-renders sections in place
  if (!designMode && portal.parentElement !== document.body) document.body.appendChild(portal);

  var KEY_CLOSED = "hn_welcome_closed";
  var KEY_DONE = "hn_welcome_done";
  var KEY_SEEN = "hn_welcome_seen";
  var KEY_START = "hn_welcome_start";
  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }

  var data = root.dataset;
  var state = data.state;
  var code = data.code || "";
  var enabled = data.enabled === "true";
  var preview = /[?&]hn_welcome=preview\b/.test(window.location.search);
  var dialog = root.querySelector(".hn-welcome__dialog");
  var lastFocus = null;
  var isOpen = false;

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll("a[href], button, input:not([type=hidden]), [tabindex]:not([tabindex='-1'])"),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add("hn-welcome-lock");
    window.requestAnimationFrame(function () { root.classList.add("is-open"); });
    set("sessionStorage", KEY_SEEN, "1");
    var first = root.querySelector(".hn-welcome__input") || root.querySelector("[data-hn-welcome-copy]") || dialog;
    window.setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 60);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove("is-open");
    document.documentElement.classList.remove("hn-welcome-lock");
    window.setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
    if (state === "signup" && !preview) set("localStorage", KEY_CLOSED, String(Date.now()));
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-hn-welcome-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("keydown", function (e) {
    if (!isOpen) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key !== "Tab") return;
    var f = focusables();
    if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  });

  // client-side check before the normal form post
  var form = formEl;
  var input = root.querySelector(".hn-welcome__input");
  var invalid = root.querySelector("[data-hn-welcome-invalid]");
  if (form && input) {
    form.addEventListener("submit", function (e) {
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
      if (!ok) {
        e.preventDefault();
        if (invalid) invalid.hidden = false;
        input.setAttribute("aria-invalid", "true");
        input.focus();
      }
    });
    input.addEventListener("input", function () {
      if (invalid) invalid.hidden = true;
      input.removeAttribute("aria-invalid");
    });
  }

  // copy the code
  var copyBtn = root.querySelector("[data-hn-welcome-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var done = function () {
        var label = copyBtn.textContent;
        copyBtn.textContent = copyBtn.getAttribute("data-copied-label") || "Copied";
        window.setTimeout(function () { copyBtn.textContent = label; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else {
        var t = document.createElement("textarea");
        t.value = code; t.setAttribute("readonly", ""); t.style.position = "fixed"; t.style.opacity = "0";
        document.body.appendChild(t); t.select();
        try { document.execCommand("copy"); } catch (e) {}
        document.body.removeChild(t); done();
      }
    });
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("customer_posted");
      url.hash = "";
      window.history.replaceState(window.history.state, "", url.pathname + url.search);
    } catch (e) {}
  }

  // theme editor: open while the section is selected
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:select", function (e) { if (sectionEl && e.target === sectionEl) open(); });
    document.addEventListener("shopify:section:deselect", function (e) { if (sectionEl && e.target === sectionEl) close(); });
    return;
  }

  if (state === "success") {
    set("localStorage", KEY_DONE, "1");
    cleanUrl();
    open();
    if (code) {
      window.fetch("/discount/" + encodeURIComponent(code) + "?redirect=%2Fcart.js", { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) return;
          var applied = root.querySelector("[data-hn-welcome-applied]");
          if (applied) applied.hidden = false;
        })
        .catch(function () {});
    }
    return;
  }
  if (data.errors === "true") { cleanUrl(); open(); return; }
  if (preview) { open(); return; }
  if (!enabled) return;
  if (get("localStorage", KEY_DONE)) return;
  if (get("sessionStorage", KEY_SEEN)) return;
  var closedAt = +get("localStorage", KEY_CLOSED) || 0;
  var hideMs = (+data.hideDays || 14) * 86400000;
  if (closedAt && Date.now() - closedAt < hideMs) return;

  // time on site, counted across pages in this tab
  var start = +get("sessionStorage", KEY_START) || 0;
  if (!start) { start = Date.now(); set("sessionStorage", KEY_START, String(start)); }
  var wait = Math.max(1500, start + (+data.delay || 12) * 1000 - Date.now());
  var timer = window.setTimeout(tryOpen, wait);

  function busy() {
    // do not jump over an open cart drawer, menu drawer or another modal
    return !!document.querySelector(
      "m-cart-drawer[open], .m-cart-drawer.m-drawer--open, .m-drawer--open, .m-menu-drawer--open, .m-modal--open, details[open].m-menu-drawer__container"
    );
  }
  function tryOpen() {
    if (isOpen || get("sessionStorage", KEY_SEEN)) return;
    if (busy()) { timer = window.setTimeout(tryOpen, 4000); return; }
    window.clearTimeout(timer);
    open();
  }

  if (data.exitIntent === "true" && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    var armedAt = Date.now() + 4000;
    document.addEventListener("mouseout", function (e) {
      if (e.relatedTarget || e.clientY > 0 || Date.now() < armedAt) return;
      tryOpen();
    });
  }
})();
